import React from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import PopUp from '../../pages/PopUp';


const Footer = () => {
  return (
    <>

      {/* <div>
        <div className="embed-map-responsive"><div className="embed-map-container"><iframe className="embed-map-frame" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=400&hl=en&q=dhairya%20enterprises%20%20satna&t=&z=5&ie=UTF8&iwloc=B&output=embed" /><a href="https://classicjoy.games" style={{ fontSize: '2px!important', color: 'gray!important', position: 'absolute', bottom: 0, left: 0, zIndex: 1, maxHeight: 1, overflow: 'hidden' }}>NES Games</a></div><style dangerouslySetInnerHTML={{ __html: ".embed-map-responsive{position:relative;text-align:right;width:100%;height:0;padding-bottom:25%;}.embed-map-container{overflow:hidden;background:none!important;width:100%;height:100%;position:absolute;top:0;left:0;}.embed-map-frame{width:100%!important;height:100%!important;position:absolute;top:0;left:0;}" }} /></div>
      </div> */}

      <div className="mapouter"><div className="gmap_canvas"><iframe className="gmap_iframe" width="100%" frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src="https://maps.google.com/maps?width=1600&height=400&hl=en&q=CND, 01, Ganesh Nagar, Tehsil Raghuraj Nagar, Dhairya Enterprises, near Chandra Say, Satna, Madhya Pradesh 485005, India&t=&z=14&ie=UTF8&iwloc=B&output=embed" /><a href="https://embed-googlemap.com">google maps embed</a></div><style dangerouslySetInnerHTML={{ __html: ".mapouter{position:relative;text-align:right;width:100%;height:400px;}.gmap_canvas {overflow:hidden;background:none!important;width:100%;height:400px;}.gmap_iframe {height:400px!important;}" }} /></div>


      <footer className="main-footer dark-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-12">
              {/* About Footer Start */}
              <div className="about-footer">
                {/* Footer Logo Start */}
                <div className="footer-logo">
                  <img src="assets/img/cnd_logo_1.webp" alt />
                </div>
                <div className="footer-social-links" style={{ marginTop: "-10px" }}>
                  <h3>Follow Us On Social :</h3>
                  <ul>
                    <li><Link to="https://www.instagram.com/mahuasaktiblend?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="blank"><i className="fa-brands fa-instagram" /></Link></li>
                    <li><Link to="https://www.facebook.com/profile.php?id=61592758712504"><i className="fa-brands fa-facebook-f" target="blank" /></Link></li>
                    <li><Link to="https://www.youtube.com/@dhairyaenterprisesc.n.d857"><i className="fa-brands fa-youtube" target="blank" /></Link></li>
                    {/* <li><a to="#"><i className="fa-brands fa-youtube" /></a></li>
                    <li><a to="#"><i className="fa-brands fa-x-twitter" /></a></li> */}


                  </ul>
                </div>
                {/* Footer Social Link End */}
              </div>
              {/* About Footer End */}
            </div>
            <div className="col-lg-8">
              {/* Footer Links Box Start */}
              <div className="footer-links-box">
                {/* Footer Links Start */}
                <div className="footer-links">
                  <h3>quick links</h3>
                  <ul>
                    <li><Link to="/">Home</Link></li>
                    <li><Link to="/about-us">About us</Link></li>

                  </ul>
                </div>
                {/* Footer Links End */}
                {/* Footer Links Start */}
                <div className="footer-links">
                  <h3>Customer Service</h3>
                  <ul>
                    <li><Link to="https://www.indiapost.gov.in/" target="_blank">Track Order</Link></li>
                    <li><Link to="/contact-us">Contact us</Link></li>
                  </ul>
                </div>
                {/* Footer Links End */}
                {/* Footer Links Start */}
                <div className="footer-links footer-contact-links">
                  <h3>Contact Information</h3>
                  {/* Footer Contact List Start */}
                  <div className="footer-contact-list">
                    {/* Footer Contact Item Start */}
                    <div className="footer-contact-item">
                      <div className="icon-box">
                        <img src="./assets/images/icon-phone-white.svg" alt />
                      </div>
                      <div className="footer-contact-content">
                        <p><a href="tel:+916262556132">+91 6262556132</a></p>
                      </div>
                    </div>
                    {/* Footer Contact Item End */}
                    {/* Footer Contact Item Start */}
                    <div className="footer-contact-item">
                      <div className="icon-box">
                        <img src="./assets/images/icon-mail-white.svg" alt />
                      </div>
                      <div className="footer-contact-content">
                        <p><a href="mailto:cndsuperfood@gmail.com">cndsuperfood@gmail.com</a></p>
                      </div>
                    </div>
                    {/* Footer Contact Item End */}
                  </div>
                  {/* Footer Contact List End */}
                </div>
                {/* Footer Links End */}
              </div>
              {/* Footer Links Box End */}
            </div>
          </div>
        </div>


        {/* Footer Copyright Start */}
        <div className="footer-copyright">
          <div className="container">
            <div className="row">
              {/* Footer Copyright Box Start */}
              <div className="footer-copyright-box">
                {/* Footer Copyright Text Start */}
                <div className="footer-copyright-text">
                  <p > <a style={{ color: "white" }} href="tel:+918982471422">2026 © Designed by | CND Super Food</a></p>
                </div>
              </div>
              {/* Footer Copyright Box End */}
            </div>
          </div>
        </div>
        {/* Footer Copyright End */}
      </footer>
      {/* <PopUp /> */}
      <WhatsappIcon />



    </>
  )
}

export default Footer